import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Checkbox, Paper } from '@material-ui/core';
const styles = (theme) => ({
  outerMostWrapperActual: {
    zIndex: 2,
    position: 'absolute',
    pointerEvents: 'auto',
    display: 'flex',
    backgroundColor: theme.ModalBGColor,
    top: 80,
    right: '2%',
    padding: '5px',
    width: '178px'
  },
  outerMostWrapperPlanned: {
    zIndex: 2,
    position: 'absolute',
    pointerEvents: 'auto',
    display: 'flex',
    backgroundColor: theme.ModalBGColor,
    top: 30,
    right: '2%',
    padding: '5px',
     width: '178px'
  },
  outerMostWrapperGPS: {
    zIndex: 2,
    position: 'absolute',
    pointerEvents: 'auto',
    display: 'flex',
    backgroundColor: theme.ModalBGColor,
    top: 130,
    right: '2%',
    padding: '5px',
     width: '178px'
  },
  actualRouteHeader: {
    fontWeight: 'bold',
    fontSize: '10px',
    lineHeight: '14px',
    color: theme.deviationStopColor
  },
  plannedRouteHeader: {
    fontWeight: 'bold',
    fontSize: '10px',
    lineHeight: '14px',
    color: theme.ToggleIconColor
  },
  gpsRouteHeader: {
    fontWeight: 'bold',
    fontSize: '10px',
    lineHeight: '14px',
  },
  routeDetail: {
    fontSize: '9px',
    lineHeight: '12px',
    textAlign: 'center',
    color: theme.iconColor,
    paddingTop: '5px'
  },
  root: {
    padding: "0 6px 0 0",
    color: theme.gridIconBorderColor,
    '&$checked': {
      color: theme.palette.primary.main
    }
  },
  checked: {
    color: theme.palette.primary.main    
  }
});
const getWrapperClass = (type, classes) => {
  switch (type) {
    case 'Actual':
      return { paperClass: classes.outerMostWrapperActual, headerClass: classes.actualRouteHeader };
    case 'GPS':
      return { paperClass: classes.outerMostWrapperGPS, headerClass: classes.gpsRouteHeader };
    default:
      return {
        paperClass: classes.outerMostWrapperPlanned,
        headerClass: classes.plannedRouteHeader
      };
  }
};

const RouteLegend = ({ classes, header, label, type, checked, onChange }) => {
  const { paperClass, headerClass } = getWrapperClass(type, classes);
  return (
    <Paper className={paperClass}>
      <span>
        <Checkbox
          checked={checked}
          key={label}
          onChange={(e) => onChange(e, type)}
          classes={{
            root: classes.root,
            checked: classes.checked
          }}
        />
      </span>
      <span>
        <div className={headerClass}>{header}</div>
        <div className={classes.routeDetail}>{label}</div>
      </span>
    </Paper>
  );
};

export default withStyles(styles)(RouteLegend);
